import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useRef, useState } from 'react';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import styles from './WebviewContainer.module.scss';
export const WebviewContainer = ({ webview }) => {
    const [hideLoader, setHideLoader] = useState(false);
    const ref = useRef(null);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: cn(styles.iframeWrapper, styles[webview.height || '']), children: [_jsx("span", { className: cn({ [styles.hide]: hideLoader }), children: _jsx(LoadingIcon, {}) }), _jsx("iframe", { allow: "geolocation", ref: ref, id: webview.action_id, title: webview.name, src: webview.url, onLoad: () => setHideLoader(true), className: cn({ [styles.hide]: !hideLoader }) })] }) }));
};
